"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApproveAttestationBodyToJSON = exports.ApproveAttestationBodyFromJSONTyped = exports.ApproveAttestationBodyFromJSON = void 0;
var runtime_1 = require("../runtime");
function ApproveAttestationBodyFromJSON(json) {
    return ApproveAttestationBodyFromJSONTyped(json, false);
}
exports.ApproveAttestationBodyFromJSON = ApproveAttestationBodyFromJSON;
function ApproveAttestationBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'attestationId': json['attestationId'],
        'approvedUsdAmount': !(0, runtime_1.exists)(json, 'approvedUsdAmount') ? undefined : json['approvedUsdAmount'],
        'adminNotes': !(0, runtime_1.exists)(json, 'adminNotes') ? undefined : json['adminNotes'],
    };
}
exports.ApproveAttestationBodyFromJSONTyped = ApproveAttestationBodyFromJSONTyped;
function ApproveAttestationBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'attestationId': value.attestationId,
        'approvedUsdAmount': value.approvedUsdAmount,
        'adminNotes': value.adminNotes,
    };
}
exports.ApproveAttestationBodyToJSON = ApproveAttestationBodyToJSON;
